import { Tooltip } from 'antd'
import { parseDisabled } from '../../utils/parseDisabled'
import { CIMSTooltipProps } from './types'

/**
 * Before writing end-to-end tests:
 *
 * `/library/testing/README.md` > End-to-End testing > Ant Design Oddities > Tooltips
 */
const CIMSTooltip: React.FC<CIMSTooltipProps> = ({
  title,
  placement,
  disabled,
  children,
}) => (
  <Tooltip placement={placement} title={parseDisabled(disabled) ?? title}>
    {children}
  </Tooltip>
)

export default CIMSTooltip
